import { v4 as uuidv4 } from 'uuid';

import { ComponentType, type IFormFieldSchema } from '../../types';
import { JsonFieldType } from '../../../types';

export const generate = (
  props?: Partial<IFormFieldSchema<Record<string, unknown>>>
): IFormFieldSchema<Record<string, unknown>> => {
  const id = uuidv4();

  // Read-only preview: a VOID field that reads/writes the operations list via the
  // form API. The mapping lives in `deriveConfig`; visuals in `nodeGroups`.
  return {
    type: JsonFieldType.VOID,
    name: props?.name || id,
    title: props?.title || 'Flow chart',
    'x-designable-id': id,
    'x-index': props?.['x-index'] || 0,
    'x-component': ComponentType.FlowChart,
    'x-component-props': {
      openInModal: true,
      triggerButtonText: 'Open flow chart',
      modalTitle: 'Manufacturing flow chart',
      ...props?.['x-component-props'],
    },
    'x-component-props-config': {},
  };
};
